import { useSelector, useDispatch } from 'react-redux';
import { alertActions } from '../../store/alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function AlertDialog() {
  const dispatch = useDispatch();

  const open = useSelector((state) => state.alert.open);

  const title = useSelector((state) => state.alert.title);

  const message = useSelector((state) => state.alert.message);

  const isLoading = useSelector((state) => state.alert.isLoading);

  const handleClose = () => {
    // Don't allow closing during loading
    if (!isLoading) {
      dispatch(alertActions.closeAlert());
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={isLoading ? undefined : handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableEscapeKeyDown={isLoading}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
          {isLoading && (
            <Box display="flex" justifyContent="center" mt={2}>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus disabled={isLoading}>
            {isLoading ? 'Please wait...' : 'Ok'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
